import React from 'react'
import { Link } from 'react-router-dom'

const ARCH_STEPS = [
  'Member',
  'Structured Intake',
  'Routing Intelligence',
  'Existing Provider Network',
  'Care Begins',
  'Continuity Monitoring',
  'Risk Detection',
  'Provider Alert',
  'Session 4 Continuity',
]

export default function HowItWorks() {
  return (
    <section className="section light" style={{ minHeight: '70vh' }}>
      <h2>How It Works</h2>
      <p className="lead muted">
        ATUUNE sits underneath the systems your organization already runs on — it doesn't replace them.
      </p>

      <div className="section-block">
        <div className="section-head"><h2>Works With Your Existing Infrastructure</h2></div>
        <p className="lead muted">ATUUNE does not replace:</p>
        <div className="cards">
          <div className="card"><h3>Provider Directories</h3></div>
          <div className="card"><h3>Scheduling</h3></div>
          <div className="card"><h3>Practice Management Systems</h3></div>
          <div className="card"><h3>EHRs</h3></div>
          <div className="card"><h3>Care Management Platforms</h3></div>
        </div>
        <p className="lead muted" style={{ marginTop: 20 }}>Instead, it sits underneath them:</p>
        <div className="arch-flow">
          {ARCH_STEPS.map((step, i) => (
            <React.Fragment key={step}>
              <div className="flow-step">{step}</div>
              {i < ARCH_STEPS.length - 1 && <div className="flow-arrow">↓</div>}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="section-block">
        <div className="section-head"><h2>Built for Enterprise Healthcare</h2></div>
        <div className="cards">
          <div className="card"><h3>Fast deployment</h3><p>Implementation is scoped around your existing provider network, not a rebuild of it.</p></div>
          <div className="card"><h3>No workflow replacement</h3><p>Care teams keep using the scheduling, EHR, and practice management tools they already know.</p></div>
          <div className="card"><h3>Works with existing provider networks</h3><p>Routing operates on the network you've already credentialed and contracted.</p></div>
          <div className="card"><h3>Minimal operational disruption</h3><p>Continuity monitoring runs in the background of care that's already underway.</p></div>
          <div className="card"><h3>Scales across regions</h3><p>The same routing and continuity layer extends across markets and provider networks as your organization grows.</p></div>
        </div>
      </div>

      <div className="actions" style={{ marginTop: 28 }}>
        <Link to="/contact">Request Demo</Link>
        <Link className="secondary outline-dark" to="/platform">Explore the Platform</Link>
      </div>
    </section>
  )
}
